import type { Attribute as AttributeModel } from '@/adapters/catalogv1.g';

export function extractAttributes(model: AttributeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.attribute_ref ?? '',
    name: model.name ?? '',
    description: model.description ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAttributes = ReturnType<typeof extractAttributes>;
